import { render, staticRenderFns } from "./forbidModal.vue?vue&type=template&id=5bd6cdd2&scoped=true&"
import script from "./forbidModal.vue?vue&type=script&lang=ts&"
export * from "./forbidModal.vue?vue&type=script&lang=ts&"
import style0 from "./forbidModal.vue?vue&type=style&index=0&id=5bd6cdd2&prod&lang=less&scoped=true&"
import style1 from "./forbidModal.vue?vue&type=style&index=1&id=5bd6cdd2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd6cdd2",
  null
  
)

export default component.exports